var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitterBlue = function SvgTwitterBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 52
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.828)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25.759,
    cy: 25.759,
    r: 25.759,
    fill: "#EFF6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636363",
    fillRule: "nonzero",
    d: "M36.977 17.7a7.08 7.08 0 0 0 2.244-3.075c-1.155.55-2.388.915-3.657 1.08a5.985 5.985 0 0 0-10.636 3.739c-.004.646.08 1.289.25 1.911-8.891-.664-12.465-6.315-12.465-6.315s-2.16 4.487 1.33 8.06a3.906 3.906 0 0 1-1.994-.498s-.748 3.822 4.071 5.9c-.677.174-1.38.23-2.077.166a6.48 6.48 0 0 0 5.484 4.154s-1.828 2.244-8.143 2.742a17.032 17.032 0 0 0 20.607-2.41s4.404-3.739 4.986-11.3l2.991-4.82-2.99.665z"
  }))));
};
export default SvgTwitterBlue;